'use client'

import NextImage, { ImageProps } from 'next/image'
import React from 'react'
import { useState } from 'react'
import { cloudflareImageLoader } from './cloudflare-loader'
import ErrorBoundary from '../utils/error-boundary'

const FALLBACK_IMAGE = `image/default/200/200/default.png`

export type SafeNumber = number | `${number}`

interface ImageCustomHeightProps extends Omit<ImageProps, 'width' | 'src'> {
  src: string
  width?: SafeNumber
  height?: SafeNumber
}

export const Image = (props: ImageCustomHeightProps) => {
  const [is404, setIs404] = useState(false)

  return (
    <>
      {props.width ? (
        <NextImage
          {...props}
          style={{ objectFit: 'contain', ...props.style }}
          src={is404 || !props.src ? FALLBACK_IMAGE : props.src}
          loader={
            props.loader ??
            (args => {
              //@ts-ignore
              if (args?.config?.allSizes) {
                //@ts-ignore
                args.config.allSizes = [props.width, props.width * 2, props.width * 3]
              }

              return cloudflareImageLoader(args)
            })
          }
          onError={() => {
            setIs404(true)
          }}
        />
      ) : (
        <img
          {...props}
          src={
            is404 || !props.src
              ? cloudflareImageLoader({ src: FALLBACK_IMAGE })
              : cloudflareImageLoader({ src: props.src, height: props.height })
          }
        />
      )}
    </>
  )
}

export default function ImageUnknownWidth(props: ImageCustomHeightProps) {
  return (
    <ErrorBoundary>
      <Image {...props} alt={props.alt} />
    </ErrorBoundary>
  )
}
